import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Popover from '@liveauctioneers/caterwaul-components/lib/Popover/Popover';
import styled from 'styled-components';

type Props = {
    elementId: string;
};

const WhyCantRetractBidPopover = ({ elementId }: Props) => {
    const whyCantRetractBidPopover = (
        <StyledDiv id={elementId}>
            <FormattedMessage id="why_cant_i_retract_bid_popover_text" />
        </StyledDiv>
    );
    return (
        <StyledPopover
            click
            hover
            placement="top"
            trigger={
                <StyledA role="button" tabIndex={0}>
                    <FormattedMessage id="retract" />
                </StyledA>
            }
        >
            {whyCantRetractBidPopover}
        </StyledPopover>
    );
};

export default React.memo<Props>(WhyCantRetractBidPopover);

const StyledPopover = styled(Popover)`
    width: 256px;
    padding: 5px;
`;

const StyledDiv = styled.div`
    text-align: left;
    line-height: 2;
`;

const StyledA = styled.a`
    max-width: 100px;
    color: ${({ theme }) => theme.colors.grey100};
    :hover {
        text-decoration: none;
        color: ${({ theme }) => theme.colors.grey100};
    }
`;
